export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '极速高清在线观看需要下载安装吗？',
    answer: '不需要。极速高清是纯网页端的在线观看平台，打开浏览器即可观看，无需下载任何软件或插件。支持Chrome、Safari、Edge等主流浏览器，真正做到即开即看。'
  },
  {
    question: '支持哪些设备在线观看？',
    answer: '极速高清支持手机、平板、笔记本电脑和台式电脑等多种设备在线观看。无论是在通勤路上用手机，还是在家用电视投屏，都能获得流畅的高清观看体验。系统会自动根据你的设备和网络状况调整最佳画质。'
  },
  {
    question: '在线观看的画质最高支持多少？',
    answer: '极速高清最高支持4K超清画质在线观看。同时提供1080P、720P、480P等多档画质选择，用户可以根据网络状况和设备性能自由切换。部分热门内容还支持HDR和杜比全景声。'
  },
  {
    question: '在线观看会消耗多少流量？',
    answer: '流量消耗取决于所选画质：4K超清约7GB/小时，1080P高清约2GB/小时，720P标清约1GB/小时。建议在WiFi环境下选择高画质，移动数据下可选择标清模式。平台还提供智能省流模式，可节省30%以上流量。'
  },
  {
    question: '需要注册才能在线观看吗？',
    answer: '部分免费内容无需注册即可在线观看。注册账号后可以享受更多权益：高清画质解锁、无广告观看、观看历史同步、个性化推荐、离线缓存等功能。注册完全免费，手机号或邮箱均可快速注册。'
  },
  {
    question: '在线观看会卡顿吗？',
    answer: '极速高清采用全球CDN加速和智能P2P传输技术，确保超低延迟的在线观看体验。在国内主要城市平均延迟低于50ms，即使在网络高峰期也能保持流畅播放。如遇卡顿，系统会自动切换至更低画质保证播放不中断。'
  },
  {
    question: '支持哪些内容类型？',
    answer: '极速高清提供电影、电视剧、综艺、纪录片、动漫、少儿等丰富内容类型的在线观看服务。平台与国内外多家内容制作方合作，持续更新海量正版高清资源，满足不同年龄层和兴趣偏好的用户需求。'
  },
  {
    question: '如何反馈问题或建议？',
    answer: '你可以通过「关于我们」页面的联系表单提交反馈，或发送邮件至客服邮箱。我们的客服团队会在24小时内回复你的问题。同时，在每个视频播放页面都设有「反馈」按钮，方便你快速报告播放问题。'
  }
];